import type { Platform } from '@multimod/shared';
import { ConnChip } from './ConnChip.js';
import type { ChatFeedStore } from '@/features/chat-feed/store';

interface Slot {
  liveChatId: string;
  viewerCount: number;
}

// Wrapper que assina o estado de conexão da plataforma no store ativo. Separado
// de `ConnCluster` pra que o hook do store (`store(selector)`) só seja chamado
// quando há store — sem hook condicional. Espelha o padrão de leaf-com-store já
// usado em ChatMessageRow/ActionsCluster (store via prop).
function LiveChip({
  store,
  platform,
  slot,
}: {
  store: ChatFeedStore;
  platform: Platform;
  slot: Slot | null;
}) {
  const state = store((s) => s.connectionByPlatform[platform]?.state ?? 'idle');
  return (
    <ConnChip
      platform={platform}
      liveChatId={slot?.liveChatId ?? null}
      viewers={slot?.viewerCount ?? null}
      state={state}
    />
  );
}

export function ConnCluster({
  twitch,
  youtube,
  store = null,
}: {
  twitch: Slot | null;
  youtube: Slot | null;
  store?: ChatFeedStore | null;
}) {
  return (
    <div
      className="flex items-center h-8 bg-bg-card border border-border rounded-md p-0.5"
      aria-label="Status das plataformas conectadas"
    >
      {store ? (
        <>
          <LiveChip store={store} platform="twitch" slot={twitch} />
          <LiveChip store={store} platform="youtube" slot={youtube} />
        </>
      ) : (
        <>
          <ConnChip platform="twitch" liveChatId={twitch?.liveChatId ?? null} viewers={twitch?.viewerCount ?? null} />
          <ConnChip platform="youtube" liveChatId={youtube?.liveChatId ?? null} viewers={youtube?.viewerCount ?? null} />
        </>
      )}
    </div>
  );
}
